import * as React from 'react';
import Filters from './components/Filters';
import Posts from './components/Posts';
import { FiltersProvider } from './contexts/filters';
import { SettingsContext } from './contexts/settings';

const App = ({ settings }) => {
    return (
        <SettingsContext.Provider value={ settings }>
            <FiltersProvider>
                <Filters />
                <Posts />
            </FiltersProvider>
        </SettingsContext.Provider>
    )
}

App.displayName = 'App';

export default App;